import { Component, OnInit } from '@angular/core';
import { HtmlRoutePages } from '~/app-routing.model';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TruckModelService } from '../../../core/services/truckmodel/truckmodel-service';
import { ScreenUtils } from '../../../core/utils/screen-utils/screen-utils';
@Component({
  selector: 'volvo-allservices-page',
  templateUrl: './allservices-page.component.html',
  styleUrls: ['./allservices-page.component.scss']
})
export class AllservicesPageComponent implements OnInit {
  isMobileOrTablet: boolean = false;
  constructor(private router: Router,private localizeRouterService: LocalizeRouterService,public TruckModelService: TruckModelService,) { 
    this.isMobileOrTablet =  ScreenUtils.isPhone() || ScreenUtils.isTablet();
  }

  ngOnInit(): void {
  }


   navigateToAllServices(): void {
      this.router.navigate([this.localizeRouterService.translateRoute(HtmlRoutePages.services)]);
    }
  
}
